import { Vue, Component } from 'vue-property-decorator';
import CustomRostering from './roster-types/custom-rostering/custom-rostering';
import OneRoster0 from './roster-types/oneroster0/oneroster0';
import OneRoster1 from './roster-types/oneroster1/oneroster1';
import RosterClasslink from './roster-types/roster-classlink/roster-classlink';
import RosterClever from './roster-types/roster-clever/roster-clever';

@Component({
    name: 'roster-setup',
    components: {
        classlink: RosterClasslink,
        clever: RosterClever,
        customRostering: CustomRostering,
        oneRoster0: OneRoster0,
        oneRoster1: OneRoster1,
    },
})

export default class RosterSetup extends Vue {

    public isUploading: boolean = false;

    public userData: any = {};

    public selectedKey: any = 'customRostering';

    public activeComponentSSO: any = '';

    public ssoDetails: any = {};

    private providerList: any = [
        {
            text: 'Custom Rostering',
            value: 'customRostering',
        },
        {
            text: 'Classlink',
            value: 'classlink',
        },
        {
            text: 'Clever',
            value: 'clever',
        },
        {
            text: 'Oneroster 1.0',
            value: 'oneroster0',
        },
        {
            text: 'Oneroster 1.1',
            value: 'oneroster1',
        },
    ];

    private ssoComponents: any = {
        customRostering: 'customRostering',
        classlink: 'classlink',
        clever: 'clever',
        oneroster0: 'oneRoster0',
        oneroster1: 'oneRoster1',
    };

    private created() {
        this.onChangeSSOType();
    }

    private onBackTolist(key: any) {
        this.$emit('onSwitchComponent', key);
    }

    private onChangeSSOType() {
        this.ssoDetails = {};
        this.activeComponentSSO = this.ssoComponents[this.selectedKey];
    }

    private onNext() {
        const doNothing = '';
        // console.log('ssoDetails', this.ssoDetails);
    }

}
